export default __webpack_public_path__ + "static/media/thank-you.2f5554fa.webp";